import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';

import { FormBox } from '../../../css';

const SelectField = ({
  label,
  errors,
  touched,
  name,
  id,
  list,
  allowOptionNull,
  errorIcon,
  val
}) => {
  return (
    <FormBox>
      <div className="main-content-form-headers">
        <span>{label}</span>
      </div>
      <div
        style={{ position: 'relative', width: '100%', marginBottom: '-1.5rem' }}
        className={`frg-select-container color-light input-container ${errors[name] && touched[name] ? 'error' : ''
          }`}
      >
        <Field as="select" id={id} name={name} className="select-style">
          {allowOptionNull && <option value={null} />}
          {list.map(l => (
            <option key={l.id} value={l.id}>
              {l[val]}
            </option>
          ))}
        </Field>
        <div className="error_messages">
          <span className="registration-error">{errors[name]}</span>
        </div>
        <div id="username_error_icon" className="error_messages_icon">
          <img src={errorIcon} alt="error_icon" />
        </div>
      </div>
    </FormBox>
  );
};

SelectField.propTypes = {
  label: PropTypes.string.isRequired,
  errors: PropTypes.objectOf(PropTypes.string),
  touched: PropTypes.objectOf(PropTypes.bool),
  name: PropTypes.string.isRequired,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  errorIcon: PropTypes.string,
  list: PropTypes.arrayOf(PropTypes.any).isRequired,
  allowOptionNull: PropTypes.bool,
  val: PropTypes.string.isRequired
};

SelectField.defaultProps = {
  errors: {},
  touched: {},
  id: null,
  errorIcon: null,
  allowOptionNull: true
};

export default SelectField;
